import React from "react";

export default function Step12() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          12
        </div>
        <div className="">
          <h1>
            O último passo é enviar um <b>documento de identidade</b> (RG, CNH,
            etc.) e um <b>comprovante de endereço</b> (conta de água, luz,
            telefone, preferencialmente no seu nome, se não puder, enviar de
            seus pais).
          </h1>
          <p className="mt-1">
            Precisa ser uma <b>FOTO</b> do documento <b>ORIGINAL</b> - não pode
            ser escaneado ou fotocópia.
          </p>
        </div>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3632.jpg?alt=media&token=c53a91a6-0583-4a4f-a92e-0128dd2070df"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
